import { AsyncPaginate } from 'react-select-async-paginate'
import { makeGetRequest } from 'utils/api'

const PaginatedSelect = ({
  size = 20,
  serializer,
  url,
  isMulti,
  className,
  value,
  onChange,
  debounce = 300,
  defaultOptions = false,
  defaultAction,
  isPortal = false,
  id,
  isClearable,
  customStyles,
  selectKey,
  components,
  placeholder,
  isDisabled
}) => {
  const loadOptions = async (search, loadedOptions, { page }) => {
    const response = await makeGetRequest(url, {
      params: {
        page,
        size,
        name: search
      }
    })

    if (defaultOptions && page === 0 && !search) {
      defaultAction && defaultAction(response)
    }

    return {
      options: serializer ? serializer(response.content) : response.content,
      hasMore: !response.last,
      additional: {
        page: page + 1
      }
    }
  }

  const styles = {
    option: (styles, { data }) => {
      return {
        ...styles,
        color: data.color
      }
    }
  }
  if (isPortal) {
    styles.menuPortal = base => ({ ...base, zIndex: 9999 })
  }
  if (isMulti) {
    styles.multiValueLabel = (styles, { data }) => {
      if (data.color) {
        return {
          ...styles,
          color: data.color
        }
      }
      return styles
    }
  }

  return (
    <AsyncPaginate
      key={selectKey}
      defaultOptions={defaultOptions}
      debounceTimeout={debounce}
      value={value}
      className={className}
      loadOptions={loadOptions}
      isMulti={isMulti}
      onChange={onChange}
      additional={{
        page: 0
      }}
      styles={{ ...customStyles, ...styles }}
      menuPortalTarget={isPortal ? document.body : null}
      id={id}
      isClearable={isClearable}
      components={components}
      placeholder={placeholder}
      isDisabled={isDisabled}
    />
  )
}

export default PaginatedSelect
